import React, { useState } from 'react';
import { Grid, IconButton, TextField } from '@material-ui/core';

import ModalDialog from '../ModalConfirmation';
import TooltipWrapper from '../../components/TooltipWrapper';

const IconWithPopUp = ({
  handler,
  title,
  children,
  iconClassName,
  tooltipTitle,
  disabled,
  withReason = false,
  reasonPlaceholder = '',
  reasonRows = 5,
  confirmButtonText = 'Yes',
  cancelButtonText = 'No'
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reason, setReason] = useState('');

  const onConfirmDeleteReference = () => {
    handler(withReason ? reason.trim() : undefined);
    setReason('');
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setReason('');
    setIsModalOpen(false);
  };
  const handleClick = () => {
    if (!disabled) {
      setIsModalOpen(true);
    }
  };
  return (
    <Grid item>
      <TooltipWrapper tooltip title={tooltipTitle}>
        <IconButton className={iconClassName} size="small" onClick={handleClick}>
          {children}
        </IconButton>
      </TooltipWrapper>
      <ModalDialog
        title={title}
        isModalOpen={isModalOpen}
        onCancel={handleCancel}
        onConfirm={onConfirmDeleteReference}
        confirmDisabled={withReason && !reason.trim()}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
      >
        {withReason && (
          <TextField
            placeholder={reasonPlaceholder}
            value={reason}
            onChange={event => setReason(event.target.value)}
            fullWidth
            multiline
            rows={reasonRows}
            variant="outlined"
            margin="dense"
            autoFocus
          />
        )}
      </ModalDialog>
    </Grid>
  );
};

export default IconWithPopUp;
